import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchTranslations, selectTranslationsFetchedLanguage, selectTranslationsIsFetching } from '../../features/translations/translationsSlice';
import LoadingOverlay from '../common/LoadingOverlay';
import { fetchCompanies, selectCompaniesAreFetching, selectCompany } from '../../features/company/companySlice';
import { getCognitoUserData } from '../../features/auth/authSlice';

interface ITranslatorProps {
  isPublic?: boolean;
}
export const Translator: React.FunctionComponent<ITranslatorProps> = ({ children, isPublic }) => {
  const dispatch = useDispatch();
  const fetchedLanguage = useSelector(selectTranslationsFetchedLanguage)
  const companiesFetching = useSelector(selectCompaniesAreFetching);
  const translationsFetching = useSelector(selectTranslationsIsFetching);
  const cognitoUserData = useSelector(getCognitoUserData);
  const [loadOnPublic, setLoadOnPublic] = useState(isPublic);
  const companyId = cognitoUserData
    ? cognitoUserData["custom:company"]
    : "";
  const companyFromStore = useSelector(
    selectCompany(companyId)
  );
  let language = companyFromStore || (!companyId && cognitoUserData) ? (companyFromStore?.language ?? 'es') : null;

  useEffect(() => {
    if ((!translationsFetching && !companiesFetching && language && fetchedLanguage !== language) || loadOnPublic) {
      setLoadOnPublic(false);
      dispatch(fetchTranslations(language ?? 'es'));
    }
  }, [dispatch, language, companiesFetching, fetchedLanguage, translationsFetching, loadOnPublic]);

  useEffect(() => {
    if (!companyFromStore && !isPublic) {
      dispatch(fetchCompanies());
    }
  }, [companyFromStore, dispatch, isPublic]);
  
  if (isPublic) {
    language = 'es';
  }

  if (translationsFetching || !language || fetchedLanguage === 'unset') {
    return <LoadingOverlay spinning />;
  }

  return <>{children}</>;
};